module.exports = __webpack_public_path__ + "static/img/04.c1a44f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/bounty/tutorial/04.svg
// module id = 4DZz
// module chunks = 13